import api from "./apiMasterData.js";

export default {
  SearchPartners(user) {
    return api.post("Partners/SearchPartners", user);
  },
  // Search partners by code/name; returns full rows (incl. CompanyCode) with no server-side cap.
  SearchPartnersByNameAltkn(search) {
    return api.post("Partners/SearchPartnersByNameAltkn", search);
  }
};
